const postBlock = (item) => {
  return {
    contentId: item.contentId,
    chapters: item.numberChaptersBlock,
    planningDates: {
      delivery: item.delivery,
      release: item.release,
      channelNotes: item.channelNotes,
      contentAssessment: item.contentAssessment,
      diversityAssessment: item.diversityAssessment,
    },
  };
};

const patchMaterials = (item) => {
  return {
    id: item.id,
    contentId: item.contentId,
    planningDates: {
      delivery: item.delivery,
      release: item.release,
      channelNotes: item.channelNotes,
      productionAssessment: item.productionAssessment,
      contentAssessment: item.contentAssessment,
      diversityAssessment: item.diversityAssessment,
    }
  };
};

const patchBlock = (item) => {
  return {
    id: item.id,
    contentId: item.contentId,
    dates: {
      delivery: item.delivery,
      release: item.release,
      channelNotes: item.channelNotes,
      productionAssessment: item.productionAssessment,
      contentAssessment: item.contentAssessment,
      diversityAssessment: item.diversityAssessment,
    }
  };
};

const postDramaturgyShortPlanning = (item) => {
  return {
    contentId: item.contentId,
    typeId: item.typeId,
    version: item.version,
    episodeNumber: item.chapterNumber ?? item.episodeNumber,
    planningDates: {
      delivery: item.delivery,
      release: item.release,
      channelNotes: item.channelNotes,
      contentAssessment: item.contentAssessment,
      diversityAssessment: item.diversityAssessment,
      productionAssessment: item.productionAssessment,
    },
  };
};

const postVarietiesPlanning = (item) => {
  return {
    contentId: item.contentId,
    typeId: item.typeId,
    version: item.version,
    planningDates: {
      delivery: item.delivery,
      release: item.release,
      channelNotes: item.channelNotes,
      contentAssessment: item.contentAssessment,
      diversityAssessment: item.diversityAssessment,
      productionAssessment: item.productionAssessment,
    },
  };
};

const putPlanning = (item) => {
  return {
    contentId: item.contentId,
    typeId: item.typeId,
    version: item.version,
    chapterNumber: item.chapterNumber ?? item.episodeNumber,
    scheduleDelivery: item.scheduleDelivery,
    scheduleRelease: item.scheduleRelease,
    plannedContentSight: item.plannedContentSight,
    plannedProdutionSight: item.plannedProdutionSight,
    plannedArtisticApproval: item.plannedArtisticApproval,
    plannedChannelFeedback: item.plannedChannelFeedback,
  };
};

export const PLANNING_CONTRACTS = {
  postBlock,
  patchBlock,
  patchMaterials,
  postDramaturgyShortPlanning,
  postVarietiesPlanning,
  putPlanning,
};
